module.exports = __webpack_public_path__ + "partylineManage/img/GlobalcontrolDark.925cd413.png";